import * as React from 'react'

interface Props {
  sketch: any
}

export default class P5Wrapper extends React.Component<Props> {
  private canvas: any
  private wrapper: HTMLDivElement | null

  componentDidMount() {
    if (this.wrapper) {
      this.canvas = new p5(this.props.sketch, this.wrapper)
      if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
        this.canvas.myCustomRedrawAccordingToNewPropsHandler(this.props)
      }
    }
  }

  componentWillReceiveProps(newProps: Props) {
    if (this.props.sketch !== newProps.sketch && this.wrapper && this.wrapper.childNodes.length) {
      this.wrapper.removeChild(this.wrapper.childNodes[0])
      this.canvas = new p5(newProps.sketch, this.wrapper)
    }
    if ( this.canvas.myCustomRedrawAccordingToNewPropsHandler ) {
      this.canvas.myCustomRedrawAccordingToNewPropsHandler(newProps)
    }
  }

  componentWillUnmount() {
    this.canvas.remove()
  }

  render() {
    return <div ref={wrapper => this.wrapper = wrapper} />
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/P5Wrapper.tsx